/* eslint-disable camelcase, no-undef */

export default class Map {
  constructor() {
    this.selector = '.c-map';

    this.classNames = {
      mapActive: 'c-map--init',
    };

    this.nodes = {};
  }

  bootstrap() {
    this.getNodes();
    this.loadGoogleMapsApiWithKey();
  }

  getNodes() {
    this.nodes = {
      maps: [ ...document.querySelectorAll(this.selector) ],
    };
  }

  loadGoogleMapsApiWithKey() {
    const { api_key: key } = window.af_google_maps;

    if (!key) {
      return;
    }

    this.loadWithCallback(() => {
      const { maps } = this.nodes;

      if (maps.length === 0) {
        return;
      }

      maps.forEach(map => this.initMap(map));
    });

    this.loadApiScript(key);
  }

  // eslint-disable-next-line class-methods-use-this
  loadApiScript(key) {
    const script = document.createElement('script');

    script.src = `//maps.googleapis.com/maps/api/js?key=${key}&callback=loadMaps`;
    script.async = true;

    document.head.appendChild(script);
  }

  // eslint-disable-next-line class-methods-use-this
  loadWithCallback(cb) {
    window.loadMaps = () => cb();
  }

  initMap(node) {
    if (!node) {
      return;
    }

    const { locations } = node.dataset;

    const locationsData = JSON.parse(locations);

    const firstLocation = locationsData[0];

    const center = {
      lat: this.parseStringToFloat(firstLocation.lat),
      lng: this.parseStringToFloat(firstLocation.lng),
    };

    const centerPoint = new google.maps.LatLng(center);

    // Init map with options
    const map = new google.maps.Map(node, {
      zoom: this.parseStringToFloat(firstLocation.zoom),

      center: centerPoint,
      zoomControl: false,
      mapTypeControl: false,
      scaleControl: false,
      streetViewControl: false,
      rotateControl: false,
      fullscreenControl: false,
    });

    this.map = map;

    // Create additional markers
    this.createMarkers({ map, markers: locations });

    // Add class to map component
    node.classList.add(this.classNames.mapActive);

    node.addEventListener('focusMarker', ({ detail }) => {
      this.focusMarker(detail.index);
    });
  }

  /**
   * Create markers and add to the map
   * @param {Map} map Google Map
   * @param {JSON} markers JSON of markers with data
   * @param {URL} icon Marker icon
   */
  createMarkers({ map, markers, icon }) {
    if (!markers || !map) {
      return;
    }

    const parsedMarkers = JSON.parse(markers);

    if (parsedMarkers.length === 0) {
      return;
    }

    this.markers = [];

    parsedMarkers.forEach((marker, idx) => {
      const { lat, lng, in_window_text } = marker;

      if (!lat || !lng) {
        return;
      }

      const markerElement = new google.maps.Marker({
        position: {
          lat: this.parseStringToFloat(lat),
          lng: this.parseStringToFloat(lng),
        },
        map,
        ...icon ? { icon } : {},
        zIndex: idx,
      });

      const infoWindow = new google.maps.InfoWindow({
        content: in_window_text,
      });

      markerElement.openWindow = () => {
        infoWindow.open({
          anchor: markerElement,
          map,
          shouldFocus: false,
        });
      };

      markerElement.closeWindow = () => {
        infoWindow.close();
      };

      markerElement.addListener('click', () => {
        markerElement.openWindow();
      });

      if (idx === 0) {
        markerElement.openWindow();
      }

      this.markers[idx] = markerElement;
    });

    window.focusMarker = this.focusMarker.bind(this);
  }

  focusMarker(idx) {
    const index = parseInt(idx, 10);
    const marker = this.markers[index] || false;

    if (!marker) {
      return;
    }

    this.map.panTo(marker.position);

    this.markers.forEach(markerItem => markerItem.closeWindow());
    marker.openWindow();
  }

  // eslint-disable-next-line class-methods-use-this
  parseStringToFloat(string) {
    return parseFloat(string);
  }
}
